export default __webpack_public_path__ + "static/media/2149.4db5de60.png";